import { render } from "./SideMenuRenewal.vue?vue&type=template&id=fed9c2b2"
import script from "./SideMenuRenewal.vue?vue&type=script&lang=js"
export * from "./SideMenuRenewal.vue?vue&type=script&lang=js"

import "./SideMenuRenewal.vue?vue&type=style&index=0&id=fed9c2b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__